<template>
	<div>
		<b-row :class="`mt-${marginTop}`">
			<b-col cols="2" sm="4" class="d-none d-sm-block"></b-col>
			<b-col align-self="end" cols="6" sm="4" class="float-right my-1">
				<b-button
					v-if="!viewMode"
					type="button"
					variant="outline-secondary"
					class="btnActionFamily"
					@click="handleCancel"
					>{{ $t('lang.buttons.cancel') }}</b-button
				>
			</b-col>

			<b-col align-self="end" cols="6" sm="4" class="float-right my-1">
				<b-button
					type="button"
					@click="confirmButtonClick"
					:class="{
						'btn-outline-dark': !enabled,
						'not-allowed': !enabled,
						'btn-secondary': enabled
					}"
					class="btnActionFamily"
					>{{
						`${viewMode ? $t('lang.buttons.back') : $t('lang.buttons.confirm')}`
					}}</b-button
				>
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	props: {
		enabled: {
			default: true,
			type: Boolean
		},
		redirectTo: {
			default: '/',
			type: String
		},
		marginTop: {
			default: 5,
			type: Number
		},
		viewMode: {
			default: false,
			type: Boolean
		}
	},
	methods: {
		confirmButtonClick() {
			if (!this.viewMode) {
				this.$emit('confirmButtonClick');
			} else {
				this.$router.push(this.redirectTo);
			}
		},
		handleCancel() {
			this.$router.push(this.redirectTo);
		}
	}
};
</script>

<style>
.not-allowed {
	cursor: not-allowed !important;
}

.not-allowed:focus {
	background-color: rgba(109, 114, 120, 0.05);
	color: #383838;
	border-color: #383838;
}

.btnFamily,
.btnActionFamily {
	height: 46px;
	float: right;
	width: 100%;
}

@media (max-width: 576px) {
	.btnFamily {
		width: 50%;
	}
	.btnActionFamily {
		width: 100%;
	}
}
</style>
